import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTar } from '@/modules'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

export const Route = createFileRoute('/admin/settings')({
  component: () => (
      <AdminSettings />
  ),
})

const AdminSettings: React.FC = () => {
  const { t } = useTar()
  useDocumentTitle('Settings', 'admin')
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h2 className="text-2xl font-bold leading-7 text-foreground sm:truncate sm:text-3xl sm:tracking-tight">
          {t('common.settings')}
        </h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('admin.settingsDescription')}
        </p>
      </div>

      {/* General Settings */}
      <div className="bg-card shadow sm:rounded-lg border border-border">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-foreground mb-4">
            {t('admin.generalSettings')}
          </h3>
          <div className="space-y-6">
            <div>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  disabled
                  className="rounded border-border text-accent shadow-sm focus:border-accent focus:ring focus:ring-accent focus:ring-opacity-50"
                />
                <span className="ms-2 text-sm text-muted-foreground">{t('admin.allowUserRegistration')}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="flex justify-end">
        <button className="bg-accent hover:bg-accent/80 text-white font-medium py-2 px-4 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 transition-colors">
          {t('admin.saveSettings')}
        </button>
      </div>
    </div>
  )
}
